import { render, staticRenderFns } from "./upload-item.vue?vue&type=template&id=4524452b&scoped=true&"
import script from "./upload-item.vue?vue&type=script&lang=js&"
export * from "./upload-item.vue?vue&type=script&lang=js&"
import style0 from "./upload-item.vue?vue&type=style&index=0&id=4524452b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524452b",
  null
  
)

export default component.exports